import { CURRENT_PRODUCT_MODE, DEFAULT_METRIC } from '@utils/constants';
import { genEIUsecases, eiPresetKeys, eiPresetTitles } from './configs/ei';
import { DEFAULT_DIMENSIONS } from '@store/trends/base/reducer';
import { genAIUsecases, aiPresetKeys, aiPresetTitles } from './configs/ai';
import {
  genAppUsecases,
  appPresetKeys,
  appPresetTitles,
  ecoServerPresetKeys,
  miniODPPresetKeys,
} from './configs/app';
import { get } from 'lodash';

const generateUsecaseConfig = {
  EI: genEIUsecases,
  AI: genAIUsecases,
  APP: genAppUsecases,
}[CURRENT_PRODUCT_MODE];

const presetKeys = {
  EI: eiPresetKeys,
  AI: aiPresetKeys,
  APP: appPresetKeys,
  ODP: miniODPPresetKeys,
  ECO_SERVER: ecoServerPresetKeys,
};

export const getValidateMetricFunc =
  (validMetricList: object) => (metricToCheck: string[] | string) => {
    if (Array.isArray(metricToCheck)) {
      const filtered = metricToCheck.filter((m) => m in validMetricList);
      return filtered.length > 0 ? filtered : [DEFAULT_METRIC];
    } else {
      return metricToCheck in validMetricList ? metricToCheck : DEFAULT_METRIC;
    }
  };

export const getValidateDimensionFunc =
  (validDimensionList: object) => (dimensionToCheck: string[] | string) => {
    if (Array.isArray(dimensionToCheck)) {
      const filtered = dimensionToCheck.filter((d) => d in validDimensionList);
      return filtered.length > 0 ? filtered : DEFAULT_DIMENSIONS[CURRENT_PRODUCT_MODE];
    } else {
      return dimensionToCheck in validDimensionList
        ? dimensionToCheck
        : DEFAULT_DIMENSIONS[CURRENT_PRODUCT_MODE][0];
    }
  };
export const buildUsecases = (metrics, dimensions, aiAlertsSensitivities = []) => {
  try {
    return generateUsecaseConfig({
      validateMetric: getValidateMetricFunc(metrics),
      validateDimension: getValidateDimensionFunc(dimensions),
      aiAlertsSensitivities,
    });
  } catch (err) {
    // pass
  }

  return [];
};

export function getDefaultConfig(supportedMetrics, dimensions, useCaseKey, aiAlertsSensitivities) {
  const usecaseConfig = buildUsecases(supportedMetrics, dimensions, aiAlertsSensitivities);
  try {
    const { config }: any = usecaseConfig.find((useCase) => useCase.key === useCaseKey);
    return {
      filter: get(config, 'common.appliedFilters[0]', []),
      chartMetrics: get(config, 'metricsChartContainer.metrics', []),
      selectedMetric: get(config, 'metricsChartContainer.metric', 'Attempts'),
      dimensionKeys: get(config, `['module:trends'].base.dimensions`, []),
      summaryWidgets: get(config, 'summaryWidgets', undefined),
    };
  } catch (error) {
    return null;
  }
}

export const validPresetKeys = Object.values(presetKeys[CURRENT_PRODUCT_MODE]);

export const presetTitles = { ...eiPresetTitles, ...aiPresetTitles, ...appPresetTitles };
